import PaymentMethodAdmin from 'src/adminPanel/entities/PaymentMethodAdmin';
import { action } from '../actions';

export const FETCH_PAYMENT_METHODS_ADMIN = 'FETCH_PAYMENT_METHODS_ADMIN';
export const REQUEST_FETCH_PAYMENT_METHODS_ADMIN = 'REQUEST_FETCH_PAYMENT_METHODS_ADMIN';
export const SUCCESS_FETCH_PAYMENT_METHODS_ADMIN = 'SUCCESS_FETCH_PAYMENT_METHODS_ADMIN';
export const FAILURE_FETCH_PAYMENT_METHODS_ADMIN = 'FAILURE_FETCH_PAYMENT_METHODS_ADMIN';

export const fetchAllPaymentMethods = () => action(FETCH_PAYMENT_METHODS_ADMIN);
export const requestFetchAllPaymentMethods = () => action(REQUEST_FETCH_PAYMENT_METHODS_ADMIN);
export const requestFetchAllPaymentMethodsSuccess = (response: any) =>
    action(SUCCESS_FETCH_PAYMENT_METHODS_ADMIN, { response });
export const requestFetchAllPaymentMethodsFailure = (error: any) =>
    action(FAILURE_FETCH_PAYMENT_METHODS_ADMIN, { error });

export const CREATE_PAYMENT_METHOD_ADMIN = 'CREATE_PAYMENT_METHOD_ADMIN';
export const REQUEST_CREATE_PAYMENT_METHOD_ADMIN = 'REQUEST_CREATE_PAYMENT_METHOD_ADMIN';
export const SUCCESS_CREATE_PAYMENT_METHOD_ADMIN = 'SUCCESS_CREATE_PAYMENT_METHOD_ADMIN';
export const FAILURE_CREATE_PAYMENT_METHOD_ADMIN = 'FAILURE_CREATE_PAYMENT_METHOD_ADMIN';

export const createPaymentMethod = (newPaymentMethod: PaymentMethodAdmin) =>
    action(CREATE_PAYMENT_METHOD_ADMIN, { newPaymentMethod });
export const requestCreatePaymentMethod = () => action(REQUEST_CREATE_PAYMENT_METHOD_ADMIN);
export const requestCreatePaymentMethodSuccess = (response: any) =>
    action(SUCCESS_CREATE_PAYMENT_METHOD_ADMIN, { response });
export const requestCreatePaymentMethodFailure = (error: any) => action(FAILURE_CREATE_PAYMENT_METHOD_ADMIN, { error });

export const UPDATE_PAYMENT_METHOD_ADMIN = 'UPDATE_PAYMENT_METHOD_ADMIN';
export const REQUEST_UPDATE_PAYMENT_METHOD_ADMIN = 'REQUEST_UPDATE_PAYMENT_METHOD_ADMIN';
export const SUCCESS_UPDATE_PAYMENT_METHOD_ADMIN = 'SUCCESS_UPDATE_PAYMENT_METHOD_ADMIN';
export const FAILURE_UPDATE_PAYMENT_METHOD_ADMIN = 'FAILURE_UPDATE_PAYMENT_METHOD_ADMIN';

export const updatePaymentMethod = (updatedPaymentMethod: PaymentMethodAdmin) =>
    action(UPDATE_PAYMENT_METHOD_ADMIN, { updatedPaymentMethod });
export const requestUpdatePaymentMethod = () => action(REQUEST_UPDATE_PAYMENT_METHOD_ADMIN);
export const requestUpdatePaymentMethodSuccess = (response: any) =>
    action(SUCCESS_UPDATE_PAYMENT_METHOD_ADMIN, { response });
export const requestUpdatePaymentMethodFailure = (error: any) => action(FAILURE_UPDATE_PAYMENT_METHOD_ADMIN, { error });
